import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "countdown-block countdown-block__days" }
const _hoisted_2 = { class: "value" }
const _hoisted_3 = { class: "countdown-block" }
const _hoisted_4 = { class: "value" }
const _hoisted_5 = { class: "countdown-block" }
const _hoisted_6 = { class: "value" }
const _hoisted_7 = { class: "countdown-block" }
const _hoisted_8 = { class: "value" }

import { watchEffect, computed } from 'vue';
import useCountdown from '@/composables/useCountdown';
import { useStore } from 'vuex';

// #constants

export default /*@__PURE__*/_defineComponent({
  __name: 'AppAssetTimer',
  props: {
  endDate: {
    type: String,
    default: ''
  }
},
  setup(__props) {

const { setupCountdown, targetDate } = useCountdown();
const { state } = useStore();

// #props
const props = __props;

// #computed
const timeDiff = computed<number>(() => {
  const {
    sync = {
      timeDiff: 0
    }
  } = state ?? {};
  const { timeDiff = 0 } = sync ?? {};
  return timeDiff || 0;
});

// #watch
watchEffect(() => {
  if (props.endDate) {
    setupCountdown(timeDiff.value, new Date(props.endDate));
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_unref(targetDate).value)
    ? (_openBlock(), _createBlock(_component_v_row, {
        key: 0,
        class: "mb-1 bids-timing"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                class: "countdown",
                cols: "12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "3",
                    class: "countdown-wrapper"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(targetDate).countdown.days), 1),
                        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "unit" }, "Days", -1))
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "3",
                    class: "countdown-wrapper"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(targetDate).countdown.hours), 1),
                        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "unit" }, "Hours", -1))
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "3",
                    class: "countdown-wrapper"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(targetDate).countdown.minutes), 1),
                        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "unit" }, "Minutes", -1))
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "3",
                    class: "countdown-wrapper"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(targetDate).countdown.seconds), 1),
                        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "unit" }, "Seconds", -1))
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})